// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"SectionLabel_mainContainer__-W7TT","mainContainerSmall":"SectionLabel_mainContainerSmall__3jXMc"};